import React from "react";
import { Spinner } from "react-bootstrap";

import { useModuleClass } from "../hooks/useModuleClass";
import { PdfIcon } from "../../../../components/Icons/PdfIcon";

export function ModuleClass({
  previousModuleQuizAdvance,
  prevCourseModule,
  courseModule,
  moduleClass,
  moduleIndex,
  moduleClassIndex,
}) {
  const {
    loadingItemAdvance,
    toggleClass,
    isUnlocked,
    handleClickVideo,
    handleClickSlide,
  } = useModuleClass({
    previousModuleQuizAdvance,
    prevCourseModule,
    courseModule,
    moduleClass,
    moduleIndex,
    moduleClassIndex,
  });

  const isDisabled =
    loadingItemAdvance?.loading &&
    loadingItemAdvance?.sectionId === courseModule?.id &&
    loadingItemAdvance?.lessonId === moduleClass?.id;

  return (
    <div className="modern-lesson-card anim" style={{ "--delay": ".2s" }}>

      {isUnlocked() && (
        <div className="modern-lesson-lock-overlay item-locked" />
      )}

      <div className="modern-lesson-main">

        <div className="modern-lesson-index">
          {String(moduleClassIndex + 1).padStart(2, "0")}
        </div>

        <div className="modern-lesson-info">
          <span className="modern-lesson-type">
            TEMA {moduleClassIndex + 1}
          </span>

          <div className="modern-lesson-title-row">
            <i className={`${toggleClass()} modern-lesson-state-icon`} />
            <h4>{moduleClass.title}</h4>
          </div>
        </div>

        <div className="modern-lesson-actions">

          {moduleClass?.slide && (
            <button
              type="button"
              disabled={isDisabled}
              className="modern-lesson-action"
              onClick={handleClickSlide}
              title="Abrir presentación"
            >
              {isDisabled ? (
                <Spinner
                  size="sm"
                  animation="border"
                  className="m-auto"
                />
              ) : (
                <>
                  <i className="far fa-folder-open" />
                  <span>Presentación</span>
                </>
              )}
            </button>
          )}

          {moduleClass?.video && (
            <button
              type="button"
              disabled={isDisabled}
              className="modern-lesson-action modern-lesson-action-primary"
              onClick={handleClickVideo}
              title="Abrir contenido"
            >
              {isDisabled ? (
                <Spinner
                  size="sm"
                  animation="border"
                  className="m-auto"
                />
              ) : (
                <>
                  <i className="fas fa-play" />
                  <span>Ver contenido</span>
                </>
              )}
            </button>
          )}

        </div>
      </div>

      {moduleClass?.documents && moduleClass.documents.length > 0 && (
        <div className="modern-lesson-materials">

          <div className="modern-materials-title">
            <i className="fas fa-paperclip" />
            Material de apoyo
          </div>

          <div className="modern-materials-list">
            {moduleClass.documents.map((document) => (
              <a
                key={document.id}
                download
                href={document.url}
                className="modern-material-item"
              >
                <span className="modern-material-icon">
                  <PdfIcon size={20} />
                </span>

                <span className="modern-material-name">
                  {document.file_name_document}
                </span>

                <i className="fas fa-download" />
              </a>
            ))}
          </div>

        </div>
      )}

    </div>
  );
}
